export default {
    siteName: 'OMS 管理系统',
    minSiteMame: 'OMS',
    tokenKey: 'Authorization',
    USER_NAME_KEY: 'USER_NAME',
    MUTATION_FORM_TREE_DATA: "MUTATION_FORM_TREE_DATA",
    V_FORM_COMPONENTS_NAME: 'validateMyForm',
    TAX_BALANCE_EXCEL_OUT: '/oms/report/taxBalance/excelOut',
    TAX_BALANCE_IMPORT_EXCEL: '/oms/report/taxBalance/importExcel',
    DOWNLOAD_TEMP_SO_FILE_URL: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + "/oms/tempSoDownload/download?fileIds=",
    DOWNLOAD_REPORT_FILE_URL: window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + "/oms/report/downloadReportFile?fileId=",
    SO_ORDER_EXCEL_OUT: '/oms/soOrder/excelOut?type=0',
    SO_ORDER_IMPORT_EXCEL: '/oms/soOrder/excelIn',
    ML_IMPORT_EXCEL: '/oms/ml/excelIn',
    UPLOAD_AVATAR_URL:'/oms/mgr/upload',
    REFUND_IMPORT_EXCEL: '/oms/refundOrder/importExcel',
    REFUND_EXCEL_OUT: '/oms/refundOrder/excelOut',
    TEMPSO_IMPORT_EXCEL:'/oms/tempSo/importData',
    BATCH_STOCK_OUT: '/oms/batchStock/excelOut',
    BATCH_STOCK_IMPORT_EXCEL: '/oms/batchStock/importExcel',
    //DOWN_ORDERIMPORTTEP_EXCEL:window.location.href='/static/orderimporttemplate.zip',
    //DOWN_REFUND_EXCEL:window.location.href='/static/refundimporttemplate.zip',
}



// WEBPACK FOOTER //
// ./src/config/name.js